(() => {
  if (customElements.get('announcement-slider')) return;

  // Shows one still announcement at a time, then changes to the next (fade, or slide right to left).
  // Slide mode keeps a copy of the first message after the last so the loop never rewinds.
  class AnnouncementSlider extends HTMLElement {
    connectedCallback() {
      // The page can re-attach the bar; set up only once, just restart the timer
      if (this.ready) {
        if (this.items.length > 1) this.timer = setInterval(() => this.next(), this.delay);
        return;
      }
      this.ready = true;

      this.track = this.querySelector('[data-track]');
      this.items = Array.from(this.querySelectorAll('[data-slide]'));
      if (!this.track || this.items.length < 2) return;

      this.fade = this.classList.contains('announcement-slider--fade');
      this.delay = parseInt(this.dataset.speed, 10) || 5000;
      this.pos = 0;
      this.paused = false;

      if (!this.fade) {
        const clone = this.items[0].cloneNode(true);
        clone.removeAttribute('data-slide');
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('aria-hidden', 'true');
        clone.inert = true;
        this.track.appendChild(clone);
      }

      this.update();

      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') this.paused = true;
      });
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') this.paused = false;
      });

      // Theme editor: show the announcement being edited
      this.addEventListener('shopify:block:select', (event) => {
        const i = this.items.findIndex((item) => item.contains(event.target));
        if (i < 0) return;
        this.editing = true;
        this.jump(i);
      });
      this.addEventListener('shopify:block:deselect', () => {
        this.editing = false;
      });

      this.timer = setInterval(() => this.next(), this.delay);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    next() {
      if (this.paused || this.editing || document.hidden) return;

      if (this.fade) {
        this.pos = (this.pos + 1) % this.items.length;
        this.update();
        return;
      }

      this.pos += 1;
      this.update();

      // After sliding onto the copy of the first message, swap to the real one without animating
      if (this.pos === this.items.length) {
        setTimeout(() => this.jump(0), 700);
      }
    }

    jump(pos) {
      this.track.style.transition = 'none';
      this.pos = pos;
      this.update();
      void this.track.offsetWidth;
      this.track.style.transition = '';
    }

    update() {
      if (!this.fade) this.track.style.transform = `translate3d(${this.pos * -100}%, 0, 0)`;

      this.items.forEach((item, i) => {
        const active = i === this.pos % this.items.length;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', String(!active));
        item.inert = !active;
      });
    }
  }

  customElements.define('announcement-slider', AnnouncementSlider);
})();